export class ErrorFatal extends Error {
  public constructor(message: string) {
    super(message)
  }
}
